<template>
  <div id="app">
   <div class="images" v-viewer>
    <img :src="require('../assets/img/7659790acff7406fde1ff0723844760.jpg')">
   </div>
   <button type="button" @click="show">Show</button>
  </div>
 </template>
 <script>

  export default {
   data() {
 
   },
   methods: {
    show () {
     const viewer = this.$el.querySelector('.images').$viewer
     viewer.show()
    }
   }
  }
 </script>


// WEBPACK FOOTER //
// src/components/test.vue